"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/** @optimized using svgo:^3.0.2 */
export const Handmade = createSVGIcon(
  <path
    d="M8.927 24.155c2.113-2.081 2.684-4.893 1.275-6.28-1.408-1.388-4.263-.826-6.376 1.256-2.113 2.08-2.684 4.892-1.275 6.28 1.408 1.387 4.263.825 6.376-1.256ZM16.485 32.33c2.113-2.082 2.684-4.894 1.275-6.281s-4.264-.825-6.376 1.256-2.684 4.893-1.276 6.28 4.264.825 6.377-1.256ZM10.798 21.204 35 10.778M15.638 25.3 25.32 1.098"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Handmade",
  { viewBox: "0 0 36 37", titleAccess: "Handmade", fill: "none" }
);
